var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "16px",
    viewBox: "0 0 23 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Youtube-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 22.8262374 0 22.8262374 16 0 16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kepler-homepage",
    transform: "translate(-1594.000000, -7903.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Youtube-fill",
    transform: "translate(1594.000000, 7903.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3497705,2.49937301 C22.0874128,1.5159933 21.3128555,0.741436073 20.3319281,0.478950951 C18.5509974,0 11.4120836,0 11.4120836,0 C11.4120836,0 4.27320172,0 2.49236661,0.476466865 C1.50895505,0.738824597 0.736913762,1.51338182 0.474556029,2.49676153 C-0.00191083563,4.28020812 -0.00191083563,8 -0.00191083563,8 C-0.00191083563,8 -0.00191083563,11.7197919 0.474556029,13.5007544 C0.736913762,14.4841659 1.51147099,15.2586913 2.49236661,15.521049 C4.27320172,16 11.4120836,16 11.4120836,16 C11.4120836,16 18.5509974,16 20.3319281,15.521049 C21.3153396,15.2586913 22.0874128,14.4841659 22.3497705,13.5007544 C22.8262374,11.7197919 22.8262374,8 22.8262374,8 C22.8262374,8 22.8262374,4.28020812 22.3497705,2.49937301 Z M9.14459054,11.4139945 L9.14459054,4.58600552 L15.0555058,7.97449034 L9.14459054,11.4139945 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.58668496218a4ccd641e6858905674a1.svg";
export { ForwardRef as ReactComponent };